import './MetricCard.scss';

import { Link } from '@refinedev/core';
import { Skeleton } from 'antd';
import { ReactNode } from 'react';

export type MetricCardTone = 'default' | 'info' | 'warning' | 'success' | 'danger';

interface MetricCardProps {
  title: ReactNode;
  value: ReactNode;
  description?: ReactNode;
  linkTo?: string;
  linkLabel?: ReactNode;
  loading?: boolean;
  tone?: MetricCardTone;
  footer?: ReactNode;
}

/**
 * @metadata MetricCard
 * Tarjeta reusable para representar una métrica con información opcional de navegación.
 */
const MetricCard = (props: MetricCardProps) => {
  const { title, value, description, linkTo, linkLabel, loading, tone, footer } = props;
  const toneClassName = `MetricCard--${tone ?? 'default'}`;

  return (
    <article className={`MetricCard ${toneClassName}`}>
      <div className="MetricCardTitle">{title}</div>

      <div className="MetricCardValue">
        {loading ? (
          <Skeleton.Input active size="small" className="MetricCardValueSkeleton" />
        ) : (
          value
        )}
      </div>

      {description && <div className="MetricCardDescription">{description}</div>}
      {footer && <div className="MetricCardFooter">{footer}</div>}
      {linkTo && (
        <Link to={linkTo} className="MetricCardLink">
          {linkLabel ?? linkTo}
        </Link>
      )}
    </article>
  );
};

export default MetricCard;
